import { t } from '@/helpers/i18n';
const mutations = {
    setState(state, val) {
        if (typeof val == 'object' && val.val) {
            state.state = t(val.val) + (val.err ? ' ' + val.err : '');
        }
        else {
            state.state = String(t(val));
        }
    },
    clearState(state) {
        state.state = null;
    }
};
export default mutations;
